import NoteTextPreviewContainer from './NoteTextPreviewContainer';

export default NoteTextPreviewContainer;